import Vuex from 'vuex'
// import Vue from "vue";
import {router} from "../router"
import ApiAuthentificationService from '../services/ApiAuthenticationService'
import ApiService from '../services/ApiService'
import utils from './Utils';
import Vue from "vue";
import vSelect from "vue-select";

Vue.use(Vuex);
Vue.component("v-select", vSelect);

//STATE
const state = {
  oauthToken: null,
  oauthUser: null,
  scrollToBeforeLeave: 0,
  scrollToBeforeEnter: 0,
  showFooter:true,
  showHeader:true,
  isLogged: false,
  isMobile: false,
  showSettings:false,
  settings:'',
  challengeSelected:'',
  challengeUpdated:'',
  exportUpdated: '',
  indicatorUpdated: '',
  graphCriteria: '',
  newCollab:0,
  infosCollab:'',
  sidebarParcourir:[],
  currentCodePtf:null,
  pageTransition: {
    name: "router-view",
    mode: "in-out"
  },
  login:{
      title:"Connexion à votre espace",
      id:"Identifiant",
      id_placeholder:"bcatinot@feelity.fr",
      password:"Mot de passe",
      password_placeholder:"Passw0rd",
      bt_connection: 'Connexion',
      bt_forget:"Mot de passe oublié ?",
      bt_forgeted:"Réinitialiser",
      bt_cancel:"Annuler",
      error:'Erreur',
      error_desc:'Votre login ou mot de passe sont incorrect !',
      src: '/img/logo.svg',
  },
  blog:{
    title:'1ère excursion - Taux AEL',
    dateEnd:'Date de fin',
    dateStart:'31 mai',
    src:'/img/placeholder.png',
    content:'<p><b>Avec plus de 5000 nouvelles connexions en avril l´excursion se poursuit jusqu´au 31 mai.</b></p><h4>RAPPEL : bonification supplémentaire :</h4><p>de 5 points dès que le taux a progressé de 3 points (soit 15 + 5 = 20)</p><p>de 10 points dès le taux a progressé de 5 points (soit 25 + 10 = 35)</p><h4>RAPPEL : bonification supplémentaire :</h4><p>Depuis mars 2020, les marchés financiers ont enregistré une baisse significative, le seul CAC 40 perdant près de 40% de sa valeur en un mois, les marchés actions internationaux perdant 30%.</p><br><p>En notre qualité d´assureur et donc d´investisseur de long terme, nous pouvons proposer à nos clients de se repositionner sur les marchés financiers en investissant sur nos unités de comptes.</p><p>En effet, les mesures de soutien à l´économie mises en place par les banques </p>'
  },
  destination:{
    title:'Costa Rica',
    src:'/img/thumb.png',
    thumbnail1:'/img/thumbnail1.png',
    thumbnail2:'/img/thumbnail2.png',
    dateStart:'03 avril 2020',
    dateEnd:'10 avril 2020',
    content:'<p>Le Costa Rica qui nous surprendra par sa douceur de vivre, ses richesses environnementales incroyables et la gentillesse de ses habitants : Pura Vida !</p><h1><i class="fas fa-map-marker-check"></i>Lieux Incourtounables</h1><ul><li>Mascate, capitale du Sultanat d’Oman</li><li>Souk de la Muttrah, l’un des plus vieux souks de la péninsule arabique</li><li> Croisière en bateau jusqu’à la plage secrète Bandar Khayran</li><li>Baignade dans le Wadi Bani Khalid</li><li>Découverte du Wahiba Sands et de la culture bédouine</li><li>Nuit dans un camp dans le désert</li></ul>'
  },
  general:{
    favorisLabel :'Les favoris sont affichés dans le résumé',
    btWeek:'1 mois',
    btMonth: '6 mois',
    btYear: '1 an',
    labelStart : 'Début',
    labelEnd : 'Fin',
    labelTarget : 'Objectif',
    dayOf : 'j-',
    formModalTitle : 'Créer un challenge',
    formTitle : 'Titre',
    formTitlePlaceholder : 'Exemple de titre',
    formName: 'Nom',
    formNamePlaceholder : 'Le nom',
    formFirstname: 'Prénom',
    formFirstnamePlaceholder : 'Le prénom',
    formEmail: 'Email',
    formEmailPlaceholder : 'L\'email',
    formRef : 'Référence',
    formRefBtOne : 'Vie',
    formRefBtTwo : 'Dommage',
    formRefBtThree : 'Qualité',
    formCat : 'Catégorie',
    formCriteria : 'Critère',
    formStart : 'Date de début',
    formEnd : 'Date de fin',
    formDatePlaceholder : '../../....',
    formObjectif : 'Objectif (nombre)',
    formObjectifPlaceholder : '',
    formBtCancel: 'Annuler',
    formBtCreate: 'Créer',
    formBtApply: 'Appliquer',
    formBtBrowse: 'Parcourir',
    formBtSave: 'Enregistrer',
    formBtSeeAll: 'Voir tous',
    formBtExportCreate: 'Créer un export',
    formBtAddCollab: 'Ajouter un collaborateur',
    searchPlaceholder:'Rechercher un commercial',
    filter:'Filter',
    trier:'Trier',
    objective: 'Objectifs',
    objectiveAdvance: 'Objectif en avance',
    objectiveLate: 'Objectif en retard',
    objectiveDone: 'Objectif terminé',
    favorite: 'Favoris',
    modify: 'Modifier',
    modifyEvent: 'Modifier l\'évènement',
    resumeTrackingNumbers: 'Suivi des chiffres',
    resumeTrackingObjectives: 'Suivi des objectifs',
    thriftTitle: 'Épargne',
    favoritesTitle:'Gestion des favoris',
    profileTitle:'Mon profil',
    profileTitleCollaborators:'Gestion des Collaborateurs',
    profileTitleNotifications:'Réglage notifications',
    profileTitleDisconnect:' Se déconnecter',
    profileTitleInfoPerso: 'Informations personnelles',
    profileTitleInfoAgence: 'Informations agences',
    profileTitleInfoMdp: 'Modifier mon mot de passe',
    profileFormLabel:{
      lastName:'Nom',
      firstname:'Prénom',
      email:'Email',
      phone:'Téléphone',
      codeAgence:'Code agence',
      adresse1:'Adresse 1',
      adresse2:'Adresse 2',
      city:'Ville',
      postalCode:'Code postal',
      region:'Région',
      mdp:'Mot de passe',
      mdpConfirm:'Confirmer le mot de passe'
    },
    placeholder:{
      lastName:'Votre nom',
      firstname:'Votre prénom',
      email:'Votre email',
      codeAgence:'Votre code agence',
      phone:'Votre numéro de téléphone',
      address1:'Votre adresse',
      address2:'',
      city:'Votre ville',
      codePostal:'Votre code postal',
      region:'Votre région',
      mdp:'Votre mot de passe'
    },
    profileTitleCollaboratorsSave: 'Collaborateurs enregistrer',
    profileTitleCollaboratorsSubTitle: 'Vous pouvez enregistrer ici vos collaborateurs pour l’accès aux points et jeux concours',
    profileNotifications:[
        {
          name:'Mise à jours chiffres',
          checked:false,
        },
        {
          name: 'Objectif (positif, négatif)',
          checked:true,
        },
        {
          name: 'Chiffres (positif, négatif)',
          checked:false,
        },
        {
          name: 'Challenge',
          checked:false,
        },
        {
          name: 'Jeu concours',
          checked:true,
        },
        {
          name: 'Mise à jours concours',
          checked:false,
        },
      ],
    challengeTitle : 'Challenge',
    challengeBtPopupMobile : 'Créer',
    challengeBtPopupDesktop : 'Créer un challenge',
    challengeSubTitle : 'Vos challenges en cours',
    challengeSubTitleCommercial : 'Challenges commerciaux',
    notificationsTitle : 'Notifications',
    lawsStart: 'Commencer',
    destinationDescription : 'Description',
    challengesListConcoursDefault : 'Choisissez le concours',
    challengesCommercialsTitle : 'Challenge commerciaux',
    challengesClassementEvolutionTitle : 'Évolution classement',
    challengesClassementTotalTitle : 'Total points',
    exportTitle : 'Export',
    exportSubtitle : 'Liste des exports',
    commercialsTitle : 'Commerciaux',
    agentsTitle : 'Agents',
    excursionsTitle : 'Excursions',
    challengesAll : 'Tous les challenges',
    destinations : 'Destinations',
    openPdf : 'Ouvrir le pdf',
    home : 'Accueil',
    updatedThe : 'Mise à jour le ',
    contestNewsTitle : 'Actualités concours ',
    titleBestWeek: 'Top semaine',
    titleBestProgress: 'En progression',
    titleBestDecrease: 'En régression',
    btChoose: 'Veuillez choisir',
    selectChoose: 'Veuillez choisir',
    selectDateChoose: 'Veuillez choisir une date',
    targetNew : 'Nouveau',
    targetDone : 'Terminer',
    targetTodo : 'À venir',
    targetProgress:'En cours',
    profilToastTitle : 'Votre profil',
    profilSuccess : 'Vos données ont bien été mis à jour.',
    profilError : 'Une erreur est survenu, veuillez ré-essayer.',
    collabToastTitle : 'Ajout d\'un collaborateur',
    collabSuccess : 'Collaborateur ajouté.',
    collabError : 'Une erreur est survenu, veuillez ré-essayer.',
    collabToastDeleteTitle : 'Suppression d\'un collaborateur',
    collabDeleteSuccess : 'Le collaborateur a bien été effacé.',
    collabdeleteError : 'Une erreur est survenu, veuillez ré-essayer.',

  },
  sideChallenges: {
    firstPart:{
      mainTitle:'Challenges',
      buttons:[
        {
          link:'/challenges',
          text:'Tout parcourir',
          iconType:'fas',
          iconName:'trophy-alt'

        }
      ]
    },
    secondPart:{
      mainTitle:'Jeu concours',
      etiquette:'En cours',
      selects:[
        {
          text:'Pura vida 2020',
          id:'0'
        },
        {
          text:'Pura vida 2022',
          id:'0'
        }
      ],
      buttons:[
        {
          link:'/challenges/accueil',
          text:'Accueil',
          iconType:'far',
          iconName:'home-lg'
        },
        {
          link:'/challenges/classement',
          text:'Classement',
          iconType:'far',
          iconName:'trophy'
        },
        {
          link:'/challenges/excursions',
          text:'Excursions',
          iconType:'far',
          iconName:'umbrella-beach',
          notifications: '1'
        },
        {
          link:'/challenges/destinations',
          text:'Destinations',
          iconType:'far',
          iconName:'plane-departure'
        },
      ],
      buttonsAgent:[
        {
          link:'/challenges/accueil',
          text:'Accueil',
          iconType:'far',
          iconName:'home-lg'
        },
        {
          link:'/challenges/classement',
          text:'Classement',
          iconType:'far',
          iconName:'trophy'
        },
        {
          link:'/challenges/excursions',
          text:'Excursions',
          iconType:'far',
          iconName:'umbrella-beach',
          notifications: '1'
        },
        {
          link:'/challenges/destinations',
          text:'Destinations',
          iconType:'far',
          iconName:'plane-departure'
        },
      ],
      buttonsNational:[
        {
          link:'/challenges/accueil',
          text:'Accueil',
          iconType:'far',
          iconName:'home-lg'
        },
        {
          link:'/challenges/classement',
          text:'Classement',
          iconType:'far',
          iconName:'trophy'
        },
        {
          link:'/challenges/excursions',
          text:'Excursions',
          iconType:'far',
          iconName:'umbrella-beach',
          notifications: '1'
        },
        {
          link:'/challenges/destinations',
          text:'Destinations',
          iconType:'far',
          iconName:'plane-departure'
        }
      ]
    },
    threePart:{
      buttons:[
        {
          link:'/resume',
          text:'Règlement',
          iconType:'fas',
          iconName:'clipboard-list-check'

        }
      ]
    }
  },
  nationalSideSearch: {
      options: [
          { value: 'rcr', text: 'RCR' },
          { value: 'COM', text: 'Inspecteurs COM' },
          { value: 'IAP', text: 'Inspecteurs IAP' },
          { value: 'IC', text: 'Inspecteurs collectives' },
          { value: 'ICE', text: 'ICE' },
          { value: 'Agents', text: 'Agents' },
          { value: 'TOUS', text: 'Tous' }
      ],
    filters: [
      { text: 'Orange', value: 'orange' },
      { text: 'Apple', value: 'apple' },
      { text: 'Pineapple', value: 'pineapple' },
      { text: 'Grape', value: 'grape' }
    ]
  },
    rcrSideSearch: {
        options: [
          { value: 'rcr', text: 'RCR' },
          { value: 'COM', text: 'Inspecteurs COM' },
          { value: 'IAP', text: 'Inspecteurs IAP' },
          { value: 'IC', text: 'Inspecteurs collectives' },
          { value: 'ICE', text: 'ICE' },
          { value: 'Agents', text: 'Agents' },
          { value: 'TOUS', text: 'Tous' }
        ],
        filters: [
            { text: 'Orange', value: 'orange' },
            { text: 'Apple', value: 'apple' },
            { text: 'Pineapple', value: 'pineapple' },
            { text: 'Grape', value: 'grape' }
        ]
    },
  browse: {
    illustration : {
      src:'/img/browse_illustration.svg',
      title:"Aucun Favoris",
      desc:"Retrouvez ici les favoris des critères de votre suivi"
    }
  },
  listObjectiveResume:[
    {
      icon:"chart-line",
      number:"12",
      title:"Objectif positif en cours",
      target:"+1"
    },
    {
      icon:"bullseye-arrow",
      number:"23",
      title:"Objectif négatif en cours",
      target:"-1"
    },
    {
      icon:"bullseye-arrow",
      number:"2",
      title:"Objectif terminé",
      target:""
    }
  ],
  listCommercialResume:[
    {
      icon:"chart-line",
      number:"65%",
      fullname:"BASTAERT OLIVIER",
    },
    {
      icon:"bullseye-arrow",
      number:"55%",
      fullname:"BASTAERT OLIVIER",
      negatif:"true"
    },
    {
      icon:"bullseye-arrow",
      number:"33%",
      fullname:"BASTAERT OLIVIER",
    }
  ],
  productionCardSmall:[
    {
      title :'Epargne',
      id : '1',
      number :'+15 %',
      resultOne : '660',
      resultTwo : '260',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{
            data: [86,114,106,106,107],
            borderColor: "rgb(0,106,162)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 3
          }, {
            data: [282,350,411,502,635],
            borderColor: "rgb(128,128,128)",
            fill: false,
            pointRadius: 3
          }, {
            data: [168,170,178,190,203],
            borderColor: "rgb(0,106,162)",
            fill: false,
            pointRadius: 3
          }
        ]
      }
    },
    {
      title :'Epargne',
      id : '2',
      number :'-10 %',
      resultOne : '360',
      resultTwo : '860',
      date : '25 septembre 2020',
      dateTwo : '10 septembre 2019',
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{
            data: [86,114,106,106,107],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 3
          }, {
            data: [82,150,511,202,435],
            borderColor: "rgb(128,128,128)",
            fill: false,
            pointRadius: 3
          }, {
            data: [178,130,198,220,303],
            borderColor: "rgb(240,180,15)",
            fill: false,
            pointRadius: 3
          }
        ]
      }
    },
    {
      title :'Epargne',
      id : '3',
      number :'-10 %',
      resultOne : '360',
      resultTwo : '860',
      date : '25 septembre 2020',
      dateTwo : '10 septembre 2019',
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{
            data: [86,114,106,106,107],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 3
          }, {
            data: [82,150,511,202,435],
            borderColor: "rgb(128,128,128)",
            fill: false,
            pointRadius: 3
          }, {
            data: [178,130,198,220,303],
            borderColor: "rgb(240,180,15)",
            fill: false,
            pointRadius: 3
          }
        ]
      }
    }
  ],
  resumeFavorisProduction:{
      title :'Epargne',
      number :'+15 %',
      resultOne : '660',
      resultTwo : '260',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
    },
  resumeFavorisResiliation:{
      title :'Total',
      number :'-5 %',
      resultOne : '1254',
      resultTwo : '1274',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
    },
  resumeFavorisCompletude:{
      title :'Taux complétude PART',
      number :'-15 %',
      resultOne : '660',
      resultTwo : '260',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
    },
  productionCardObjectiveChart:[
    {
      id : '1',
      title :'Epargne',
      allNumber : '125 000',
      resultOne : '62 500',
      difference : '+5 000',
      date : '13 mars 2020',
      isNegative:false,
      isDone:false,
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{
            data: [282,300,461,452,635],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 3,
          }, {
            data: [282,350,411,502,635],
            borderColor: "rgb(0,106,162)",
            fill: false,
            pointRadius: 3,
          }]
      }
    },
    {
      id : '2',
      title :'Epargne 2',
      allNumber : '25 000',
      resultOne : '22 000',
      difference : '-5 000',
      date : '13 mars 2020',
      isNegative:true,
      isDone:false,
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{
            data: [282,300,461,452,635],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 3
          }, {
            data: [282,350,411,502,635],
            borderColor: "rgb(240,180,15)",
            fill: false,
            pointRadius: 3
          }]
      }
    },
    {
      id : '3',
      title :'Epargne 3',
      allNumber : '100 000',
      resultOne : '100 000',
      difference : '+5 000',
      date : '13 mars 2020',
      isNegative:false,
      isDone:true,
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{
          data: [282,300,461,452,635],
          borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 3
          }, {
            data: [282,350,411,502,635],
            borderColor: "rgb(90,197,145)",
            fill: false,
            pointRadius: 3
          }]
      }
    }
  ],
  notifications: 0,
  listeEmail: [],
}

// Getter functions
const getters = {
  getLogin( state ) {
    return state.login;
  },
  getPageTransition( state ) {
    return state.pageTransition;
  },
  getBlog( state ) {
    return state.blog;
  },
  getDestination( state ) {
    return state.destination;
  },
  getListsObjectiveResume( state ) {
    return state.listObjectiveResume;
  },
  getListsCommercialResume( state ) {
    return state.listCommercialResume;
  },
  getResumeFavorisProduction( state ) {
    return state.resumeFavorisProduction;
  },
  getResumeFavorisResiliation( state ) {
    return state.resumeFavorisResiliation;
  },
  getResumeFavorisCompletude( state ) {
    return state.resumeFavorisCompletude;
  },
  getBrowse( state ) {
    return state.browse;
  },
  getGeneral( state ) {
    return state.general;
  },
  getSideBarFavoris( state ) {
    return state.sideBarFavoris;
  },
  getNotifications( state ) {
    return state.notifications;
  },
  getListeEmail( state ) {
    return state.listeEmail;
  },
  getNationalSideSearch( state ) {
    return state.nationalSideSearch;
  },
    getRcrSideSearch( state ) {
        return state.rcrSideSearch;
    },
  getSideChallenges( state ) {
    return state.sideChallenges;
  },
  getProductionCardObjectiveChart( state ) {
    return state.productionCardObjectiveChart;
  },
  getScroll() {
    return state.scrollToBeforeEnter;
  },

  // SHOW OR NOT THE FOOTER
  getShowFooter() {
    return state.showFooter;
  },
  // SHOW OR NOT THE FOOTER
  getShowHeader() {
    return state.showHeader;
  },
  // SHOW OR HIDE Favorites Settings
  getShowSettings( state ) {
    return state.showSettings;
  },
  // GET ALL INFORMATION FROM THE USER FOR HIS PROFIL
  getSettings( state ) {
    state.settings = ApiAuthentificationService.getCurrentUser();
    return state.settings;
  },
  // GET PROFIL INITIAL
  getInitial() {
    const initial = ApiAuthentificationService.getCurrentUser();
    if(initial.name != null && initial.lastName != null){
      return utils.firstLetterUpper(initial.name) + utils.firstLetterUpper(initial.lastName);
    } else {
      return utils.twoFirstLetterUpper(initial.codeAgence);
    }
  },
  // GET FULLNAME
  getFullName() {
    const info = ApiAuthentificationService.getCurrentUser();
    return info.fullName;
  },
  getCodePtf() {
      const info = ApiAuthentificationService.getCurrentUser();
      return info.codePortefeuilles && info.codePortefeuilles.length > 0 ? [/*'total',*/ ...info.codePortefeuilles] : [];
  },
  // GET FULLNAME
  getChallengeList() {
    const list = ApiService.getConcoursApi().get();
    // console.log("getChallengeList -> list", list)
    return list;
  },
  // GET SELECTED CHALLENGES
  getChallengeSelected() {
    return state.challengeSelected;
  },
  getIsMobile() {
    return state.isMobile;
  },
  // GET UPDATED CHALLENGES
  getChallengeUpdated() {
    // console.log('state.challengeSelected = ' , state.challengeSelected);
    return state.challengeUpdated;
  },

  getExportUpdated() {
    // console.log('state.challengeSelected = ' , state.challengeSelected);
    return state.exportUpdated;
  },

  getIndicatorUpdated() {
    return state.indicatorUpdated;
  },

  getGraphCriteria() {
    return state.graphCriteria;
  },

  // GET EXCURSION SELECTED CHALLENGES
  getExcursionChallengeSelected() {
    const $selected = state.challengeSelected;
    const lists = ApiService.getConcoursApi().getExcursionList($selected);
    return lists;
  },

  // GET EXCURSION SELECTED CHALLENGES
  getExcursionChallengeDetail($id) {
    const $selected = state.challengeSelected;
    const lists = ApiService.getConcoursApi().getExcursionData($selected,$id);
    return lists;
  },

  //ADD COLLAB
  getNewCollab() {
    return state.newCollab;
  },
  //ADD COLLAB Infos
  getCollabInfos() {
    return state.infosCollab;
  },
  getCurrentCodePtf() {
      return state.currentCodePtf;
  }
};



// MUTATIONS functions
const mutations = {
  authentification (state) {
    state.isLogged = true;
  },
  incrementNotifications (state) {
    state.notifications++;
  },
  disconnect () {
    ApiAuthentificationService.signOut();
    router.push(process.env.VUE_APP_LOGIN_ROUTE);
    window.reload();
  },
  setChallengeSelected(state,value) {
    state.challengeSelected = value;
  },
  setIsMobile(state,value) {
    state.isMobile = value;
  },
  setChallengeUpdated(state,value) {
    state.challengeUpdated= value;
  },
  setExportUpdated(state,value) {
    state.exportUpdated= value;
  },
  setIndicatorUpdated(state,value) {
    state.indicatorUpdated= value;
  },
  setGraphCriteria(state,value) {
    state.graphCriteria = value;
  },
  setNewCollab(state) {
    state.newCollab += 1;
  },
  setInfosCollab(state, value) {
    state.infosCollab = value;
  },
  setCurrentCodePtf(state, value) {
      state.currentCodePtf = value;
  },
  setPageTransition(state,value) {
    // console.log(value)
    if ("default" === value) {
      state.pageTransition.name = "router-view";
      state.pageTransition.mode = "in-out";
    }
    if ("back" === value) {
      state.pageTransition.name = "router-view-back";
      state.pageTransition.mode = "in-out";
    }
  },
  setshowmenusettings(state,value) {
    state.showSettings = value;
  },
  setReceiverTo(state,value) {
    value.map(element => state.listeEmail.push(element));
  },
  setShowFooter(state,value) {
    state.showFooter = value;
    // console.log('setShowFooter = ' + state.showFooter);
  },
  setShowHeader(state,value) {
    state.showHeader = value;
    // console.log('setShowHeader = ' + state.showHeader);
  },
  setSidebarParcourir(state,value) {
    state.sidebarParcourir = value;
  }
};

//ACTION
const actions = {
  incrementNotifications ({commit}) {
    commit('incrementNotifications')
  },
  disconnect ({commit}) {
    commit('disconnect')
  },
  goBack ({commit}) {
    commit("setPageTransition", "default");
  },
  showmenusettings ({commit},value) {
    commit("setshowmenusettings", value);
  },
  setReceiver({commit},value) {
    commit("setReceiverTo", value);
  },
  showFooter({commit},value) {
    commit("setShowFooter", value);
  },
  showHeader({commit},value) {
    commit("setShowHeader", value);
  },
  setChallengeSelected({commit},value) {
    commit("setChallengeSelected", value);
  },
  setIsMobile({commit},value) {
    commit("setIsMobile", value);
  },
  setChallengeUpdated({commit},value) {
    commit("setChallengeUpdated", value);
  },
  setExportUpdated({commit},value) {
    commit("setExportUpdated", value);
  },
  setIndicatorUpdated({commit},value) {
    commit("setIndicatorUpdated", value);
  },
  setGraphCriteria({commit},value) {
    commit("setGraphCriteria", value);
  },
  setNewCollab({commit}) {
    commit("setNewCollab");
  },
  setInfosCollab({commit}, value) {
    commit("setInfosCollab",  value);
  },
  setSidebarsParcourir({commit}, value) {
    commit("setSidebarParcourir",  value);
  },
  setCurrentCodePtf({commit}, value){
      commit("setCurrentCodePtf",  value);
  },
}

export default new Vuex.Store({
    state: state,
    mutations: mutations,
    getters:getters,
    actions:actions
  })



